var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 31L9 25M19 31L19 13M29 31V23",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7C39 10.3137 36.3137 13 33 13C29.6863 13 27 10.3137 27 7C27 3.68629 29.6863 1 33 1C36.3137 1 39 3.68629 39 7Z",
    stroke: "#5784F7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9911 18C38.9911 18 39 18.6791 39 20.0001C39 28.9567 39 33.4351 36.2175 36.2176C33.435 39.0001 28.9567 39.0001 20 39.0001C11.0433 39.0001 6.56497 39.0001 3.78249 36.2176C1 33.4351 1 28.9567 1 20.0001C1 11.0434 1 6.56503 3.78249 3.78255C6.56497 1.00006 11.0433 1.00006 20 1.00006L22 1",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/IconAnalytics.bd7a411ba4b1649c8f088878a17a80c0.svg";
export { ForwardRef as ReactComponent };